<div class="cell-header-wrapper">
    <div class="row align-items-center w-100">
        <div class="col-md-10">
            <p class="labels">
                {{ fieldLabel }}
                <span *ngIf="required" class="red">*</span>
            </p>
        </div>

        <div class="col-md-1 text-end" *ngIf="cellType === FormCellType.CURRENT">
            <button
                class="add-deficiency-btn"
                type="button"
                nbButton
                status="info"
                outline
                (click)="onAddDeficiencyClicked()"
                [nbTooltip]="'Add deficiency'"
            >
                <nb-icon [pack]="'eva'" class="icon" [icon]="'plus-outline'"></nb-icon>
            </button>
        </div>

        <div class="col-md-1 text-end">
            <ngx-deficiency-alert-button
                *ngIf="countOfDeficiency > 0"
                [iconLeadLabel]="countOfDeficiency + ''"
                (onLeadIconClick)="onLeadIconClick.emit()"
            ></ngx-deficiency-alert-button>
        </div>
    </div>
</div>
